import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Grid } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { useShowRightMostPane } from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceRightPane/context/RightMostPaneContext'
import { resetBPStagedConfig } from 'api/graphQL/reactiveVars/workspaceToggles'
import { useBestPracticeManagementPanelStyles } from '../styles/useBestPracticeManagementPanelStyles'
import { BestPracticeManagementPanelActions } from './BestPracticeManagementPanelActions'
import { BestPracticeManagementPanelContent } from './BestPracticeManagementPanelContent'

interface BestPracticeManagementPanelProps {
    isSidebarVisible?: boolean
}

export const BestPracticeManagementPanel = ({
    isSidebarVisible,
}: BestPracticeManagementPanelProps) => {
    const classes = useBestPracticeManagementPanelStyles()
    const { setShowRightMostPane } = useShowRightMostPane()

    const handleClose = () => {
        setShowRightMostPane(false)
        resetBPStagedConfig()
    }

    return (
        <Grid
            data-testid="bestPracticeManagementPanel"
            className={clsx(
                classes.sidebar,
                isSidebarVisible ? classes.sidebarOpen : classes.sidebarClosed
            )}
        >
            <GridItem className={classes.panelContainer}>
                <BestPracticeManagementPanelActions onClose={handleClose} />
                <div className={classes.body}>
                    <BestPracticeManagementPanelContent />
                </div>
            </GridItem>
        </Grid>
    )
}
